import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';

@Component({
  selector: 'app-stock-information',
  templateUrl: './stock-information.component.html',
  styleUrls: ['./stock-information.component.css']
})
export class StockInformationComponent implements OnInit {

  constructor(private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
 
  SearchStockModel = {
    InventoryCategoryID: 0,
    ItemCategoryID: 0,
    ItemCode: "",
    ItemName: "",
    CurrentIndex: 0,
    PageSize: 20,
}
currentPage = 1;
pageSize = 20;
recordCount = 0;
totalPages = 0;
numberOfPages  () {

    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
}

nextPage  () {
    this.currentPage = this.currentPage + 1;

}

pageSizes  () {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;

}
Clear  () {
    this.SearchStockModel.InventoryCategoryID = 0;
    this.SearchStockModel.ItemCategoryID = 0;
    this.SearchStockModel.ItemCode = "";
    this.SearchStockModel.ItemName = "";
}
InventoryCategoryList:any;
GetInventoryCategory  () {
    this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
        this.InventoryCategoryList = data.LookupItems;
    });
};
ItemCategoryList:any;
BindItemCategory  () {
    var item = {
        ItemId: this.SearchStockModel.InventoryCategoryID
    }
    this.lookupService.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe( (data)=> {
        this.ItemCategoryList = data.LookupItems;
    });
}
StockInformationList:any;
SearchStockInformation  () {
    this.spinnerService.show();
    this.stockService.SearchStockInformation(JSON.stringify(this.SearchStockModel)).subscribe( (response)=> {
        this.StockInformationList = response.StockInformationList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);

        this.recordCount = 0;
        if (this.StockInformationList != null && this.StockInformationList.length > 0) {
            this.recordCount = this.StockInformationList[0].RecordCount;
        }
        this.numberOfPages();
     
    });
};

GetStatus  (IsActive) {
    return IsActive ? 'Yes' : 'No';
};


  ngOnInit() {
    this.GetInventoryCategory();
    this.SearchStockInformation();
  }

}
